import React from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import LayoutPage from "./containers/LayoutPage";
import OrderPage from "./containers/orders/OrderPage";


const App = () => {
	//Rotas privadas const [authenticated, setAuthenticated] = useState(false);

	return (
		<Router>
			<Routes>
				<Route path="/" element={<LayoutPage />}>
					<Route index element={<OrderPage />} />
					<Route path="/order" element={<OrderPage />} />
				</Route>
				{/* <Route
					path="/login"
					element={<LoginForm setAuthenticated={setAuthenticated} />}
				/>
				<Route
					path="/order"
					element={
						<PrivateRoute authenticated={authenticated}>
							<Order />
						</PrivateRoute>
					}
				/> */}
				<Route path="*" element={<Navigate to="/" />} />
			</Routes>
		</Router>
	);
};

// TODO: Se usar rotas privadas
// const PrivateRoute = ({ children, authenticated }) => {
// 	return authenticated ? children : <Navigate to="/login" />;
// };

export default App;
